// PT-PT relative time for notification rows ("agora", "há 5 min", "há 2 h",
// "há 3 dias"), falling back to a short date for older items.

import { tr } from "../i18nText.js";

export function formatRelativeTime(iso: string): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "";
  const seconds = Math.floor((Date.now() - then) / 1000);

  if (seconds < 60) return tr("features:notifications.relative.now", "agora");
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return tr("features:notifications.relative.minutes", `há ${minutes} min`, { count: minutes });
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return tr("features:notifications.relative.hours", `há ${hours} h`, { count: hours });
  const days = Math.floor(hours / 24);
  if (days < 7) return tr("features:notifications.relative.days", `há ${days} ${days === 1 ? "dia" : "dias"}`, { count: days });

  return new Date(then).toLocaleDateString("pt-PT", {
    day: "2-digit",
    month: "short",
  });
}
